import { useEffect } from "react";
import { useAuthUser } from "./auth"

// Pour utiliser init du framework d'authentification à l'initialisation de l'App (dans le Context de l'utilisateur)
export const PleaseDoAtAppInitializationComponent = () => {
    const { init } = useAuthUser();
    useEffect(() => init(), []);


    return <></>
}





















